const calculateDate = (initialDate: Date, countDays: number | null): Date => {
  const result = new Date(initialDate);
  if (countDays === null) {
    return result;
  }
  result.setHours(0);
  result.setMinutes(0);
  const pastDate = result.getDate() + countDays;

  result.setDate(pastDate);
  return result;
};

const getDateFormatted = (date: Date): string => {
  let dd: number | string = date.getDate();
  let mm: number | string = date.getMonth() + 1; // January is 0!

  const yyyy = date.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }
  return dd + "/" + mm + "/" + yyyy;
};

function isValidDate(d: any): boolean {
  return d instanceof Date && !isNaN(d as any);
}

const getDay = (): number => {
  return new Date().getDay() - 1;
};

const getDaysOfThisMonth = (): number => {
  return new Date().getDate() - 1;
};

const getDaysOfLastMonth = (): number => {
  const today = new Date();
  today.setMonth(today.getMonth() - 1);
  return getDay() + today.getDate() - 1;
};

const minDate = (dates: Date[]): Date => {
  const timestamps = dates.map((date) => date.getTime());
  return new Date(Math.min(...timestamps));
};

const getLastDayOfThisMonth = (date: Date): Date => {
  const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  return lastDay;
};

export {
  calculateDate,
  getDateFormatted,
  isValidDate,
  getDay,
  getDaysOfThisMonth,
  getDaysOfLastMonth,
  minDate,
  getLastDayOfThisMonth,
};
